import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';

const { consultationButton, white, black } = Colors;

export const NextButton = styled.button`
    width: 7em;
    margin-right: 1rem;
    height: 45px;
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    line-height: 0.9;
    gap: 10px;
    padding: 18px 24px !important;
    background: ${consultationButton};
    border-radius: 10px;
    ${TextStyle({ fontSize: '25px', fontWeight: '500', color: white })};
    font-style: normal;
    text-transform: capitalize;
    cursor: pointer;
    border: 2px solid rgba(117, 42, 255, 0.5);
    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
    }

    @media screen and (max-width: 500px) {
        width: 5em;
    }
`;

export const BackButton = styled.button`
    width: 5.5em;
    margin-left: 1rem;
    height: 45px;
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    line-height: 0.9;
    gap: 10px;
    padding: 18px 24px !important;
    background: ${white};
    border-radius: 10px;
    ${TextStyle({ fontSize: '25px', fontWeight: '500', color: black })};
    font-style: normal;
    text-transform: capitalize;
    cursor: pointer;
    border: 2px solid rgba(117, 42, 255, 0.5);
    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
    }
    @media screen and (max-width: 500px) {
        width: 4em;
    }
`;

// btns SALES
export const Buttons = styled.div<{ mobile?: boolean }>`
    margin-top: 25px;
    margin-left: ${(props) => (props.mobile ? '' : 'auto')};
    display: flex;
    justify-content: space-around;
    gap: 22px;
`;
export const SaveButton = styled.button<{ mobile?: boolean }>`
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: 'var(--profile-primary, #6025D8)' })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid var(--profile-primary, #6025d8); /* border-s */
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover:not(:disabled) {
        color: var(--profile-on-primary, #ffffff); /* white */
        background: var(--profile-primary, #6025d8); /* secondary-600 */
    }
    &:disabled {
        opacity: 0.5;
        color: #a0a0a0;
        border-color: #d3d3d3;
        cursor: not-allowed;
    }
    width: ${(props) => props.mobile && '137px !important'};
`;

export const salesNextButton = styled.button`
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: white })}
    background-color: var(--profile-primary, #6025d8); /* secondary-500 */
    opacity: 1;
    border: none;
    border-radius: 8px; /* border-s */
`;
